import apiUtils from '@elab/core/utils/apiUtils';

import HTTPClient from '../../utils/HTTPClient';

const getApiService = (orderCode, userId) => {
    const url = `${getBaseApiService(userId)}/orders`;
    return orderCode ? `${url}/${orderCode}` : url;
};

const getBaseApiService = userId => {
    return `${apiUtils.getBaseUri()}/users/${userId}`;
};

const getInvoiceDownloadUrlApiService = guid => {
    return `${apiUtils.getBaseUri()}/orders/${guid}/document/invoice`;
};

/**
 * Deprecated, please use getOrder
 * @param {string} orderCode - order ID
 * @param {string} userId - user ID
 * @param {boolean} isFull - true => fields=FULL, false => fields=''
 */
const loadOrder = async (orderCode, userId, isFull) => {
    return getOrder(orderCode, userId, isFull ? 'FULL' : '');
};

/**
 * Deprecated, please use getOrder
 * @param {string} orderCode - order ID
 * @param {string} userId - user ID
 * @param {boolean} isFull - true => fields=FULL, false => fields=''
 * @param {boolean} isOffline - true => url for offline order
 */
const loadOfflineOrder = async (orderCode, userId) => {
    const uri = `${apiUtils.getBaseUri()}/users/${userId ||
        'anonymous'}/orders/offline/${orderCode}?fields=FULL`;

    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load order (${response.status})`);
    }
    return await response.json();
};

/**
 * @param {string} orderCode - order ID
 * @param {string} userId - user ID
 * @param {string} fields - eg. FULL, LIVE_CHAT. etc.
 */
const getOrder = async (orderCode, userId, fields = '') => {
    const uri = `${getApiService(orderCode, userId || 'anonymous')}${
        fields !== '' ? `?fields=${fields}` : ''
    }`;

    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load order (${response.status})`);
    }
    return await response.json();
};

const repeatOrder = async (orderCode, userId, cartId) => {
    const uri = `${getApiService(orderCode, userId)}/replicate?cartId=${cartId}`;
    const response = await HTTPClient().postJson(uri);

    if (!response.ok) {
        throw new Error(`Unable to load order (${response.status})`);
    }
    return await response.json();
};

const submitEGiftCardResetEmail = async (userId, orderCode, entryNumber, { email }) => {
    const uri = `${getApiService(orderCode, userId)}/egiftcards/${entryNumber}/email`;

    const response = await HTTPClient().putJson(uri, { email });

    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
        };
    }

    return await response;
};

const getEGiftCardResetAttempts = async userId => {
    const uri = `${getBaseApiService(userId)}/attempts/E_GIFT_CARD_RESEND`;

    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load EGift Card Resend attempts (${response.status})`);
    }

    return await response.json();
};

const cancelOrder = async (userId, code) => {
    const uri = `${getBaseApiService(userId)}/orders/${code}/cancel`;
    const response = await HTTPClient().putJson(uri);

    if (!response.ok) {
        throw new Error(`Unable to cancel order (${response.status})`);
    }

    return true;
};

const downloadInvoiceFromUrl = orderGuid => {
    const uri = `${getInvoiceDownloadUrlApiService(orderGuid)}`;
    return HTTPClient().get(uri);
};

export default {
    loadOrder,
    loadOfflineOrder,
    getOrder,
    repeatOrder,
    submitEGiftCardResetEmail,
    getEGiftCardResetAttempts,
    downloadInvoiceFromUrl,
    cancelOrder,
};
